import styled from 'styled-components'
import { NoMarginRow } from 'Components/EnhacedFlexboxGrid'

export const _BodyContainer = styled(NoMarginRow)`
  min-height: calc(100vh - 240px);
  overflow-x: hidden;
  overflow-y: scroll;
  flex-wrap: nowrap;

`
